import { render, staticRenderFns } from "./customChannelContentEditor.vue?vue&type=template&id=85cf379a&"
import script from "./customChannelContentEditor.vue?vue&type=script&lang=js&"
export * from "./customChannelContentEditor.vue?vue&type=script&lang=js&"
import style0 from "./customChannelContentEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports